import _ from 'lodash';
import React from 'react';
import { Grid, Margin, Padding, Stack, Text } from '../../components';
import { coreValuesData } from './shared';

const MappedCoreValuesComponent = (props) => {
  let { startingIndex, endingIndex, columns } = props;
  return (
    <section>
      <Grid columns={columns} space={8}>
        {_.flow(
          (coreValuesData) =>
            _.map(coreValuesData, (coreValue, index) => {
              return <div key={index}>{coreValue?.icon}</div>;
            }),
          (coreValuesData) =>
            _.slice(coreValuesData, startingIndex, endingIndex)
        )(coreValuesData)}
      </Grid>
      <Grid columns={columns} space={8}>
        {_.flow(
          (coreValuesData) =>
            _.map(coreValuesData, (coreValue, index) => {
              return (
                <Text align="left" textType="primary1" key={index}>
                  {coreValue?.title}
                </Text>
              );
            }),
          (coreValuesData) =>
            _.slice(coreValuesData, startingIndex, endingIndex)
        )(coreValuesData)}
      </Grid>
      <Grid columns={columns} space={8}>
        {_.flow(
          (coreValuesData) =>
            _.map(coreValuesData, (coreValue, index) => {
              return (
                <Text align="left" textType="primary2" key={index}>
                  {coreValue?.description}
                </Text>
              );
            }),
          (coreValuesData) =>
            _.slice(coreValuesData, startingIndex, endingIndex)
        )(coreValuesData)}
      </Grid>
    </section>
  );
};

export const CoreValuesDesktop = () => {
  return (
    <Padding size={[7]} backgroundRole="primary">
      <Stack size={4}>
        <Margin size={[0, 0, 4, 0]}>
          <Text align="left" textType="heading3">
            Our Values
          </Text>
        </Margin>
        <Stack size={5}>
          <MappedCoreValuesComponent
            columns={3}
            startingIndex={0}
            endingIndex={3}
          />
          <MappedCoreValuesComponent
            columns={3}
            startingIndex={3}
            endingIndex={6}
          />
        </Stack>
      </Stack>
    </Padding>
  );
};
